import { PROPERTY_NAME, PROPERTY_VALUE, TYPE_KEY } from "../common/constant";
import { createErrorMessages, createBackendErrorMessages, messagesReceived } from "./message";

import ObjectUtils, { coalesce } from "../utils/ObjectUtils";
import rest from "../common/rest";

export const FUNDING_AREA_LIST = "fundingAreaList";
export const SELECTED_FUNDING_AREA = "selectedFundingArea";
export const SELECTED_PROGRAM = "selectedProgram";
export const SELECTED_PROGRAM_INSTANCE = "selectedProgramInstance";
export const SELECTED_PROJECT = "selectedProject";
export const PROPERTY_TARGET = "propertyTarget";

const LOAD_SUCCESSFUL_ACTION = "FUNDING_AREA.LOAD_SUCCESSFUL_ACTION";
export const SET_PROPERTY_ACTION = "FUNDING_AREA.SET_PROPERTY_ACTION";
export const RESET_FUNDING_AREA_LIST = "FUNDING_AREA.RESET_FUNDING_AREA_LIST";

const initialState = {
  [FUNDING_AREA_LIST]: {}
};

export default function reducer(state = ObjectUtils.deepClone(initialState), action) {
  let newState;
  let property;
  switch (action[TYPE_KEY]) {
    case LOAD_SUCCESSFUL_ACTION:
      property = ObjectUtils.deepClone(coalesce(state[FUNDING_AREA_LIST], {}));
      property[action[PROPERTY_TARGET]] = action[FUNDING_AREA_LIST];
      newState = Object.assign({}, state, { [FUNDING_AREA_LIST]: property });
      break;
    case SET_PROPERTY_ACTION:
      property = ObjectUtils.deepClone(coalesce(state[action[PROPERTY_NAME]], {}));
      property[action[PROPERTY_TARGET]] = action[PROPERTY_VALUE];
      newState = Object.assign({}, state, { [action[PROPERTY_NAME]]: property });
      break;
    case RESET_FUNDING_AREA_LIST:
      newState = { ...state, [FUNDING_AREA_LIST]: {} };
      break;
    default:
      newState = Object.assign({}, state, {});
      break;
  }

  return newState;
}

/**
 * Reload funding data from server, /admin/fundingarea
 */
export function reloadFundingAreaList(target) {
  return (dispatch) => {
    rest.doGet(`/admin/admin/fundingarea`).then(
      (json) => {
        if (json) {
          dispatch(loadSuccessful(json, target));
        } else {
          dispatch(messagesReceived(createErrorMessages(json)));
        }
      },
      (reason) => {
        dispatch(messagesReceived(createBackendErrorMessages(reason)));
      }
    );
  };
}

export function resetFundingAreaLists() {
  return (dispatch) => {
    dispatch({ [TYPE_KEY]: RESET_FUNDING_AREA_LIST });
  };
}

export function loadSuccessful(json, target) {
  return {
    [TYPE_KEY]: LOAD_SUCCESSFUL_ACTION,
    [FUNDING_AREA_LIST]: json,
    [PROPERTY_TARGET]: target
  };
}

export function setPropertyValue(name, target, value) {
  return {
    [TYPE_KEY]: SET_PROPERTY_ACTION,
    [PROPERTY_NAME]: name,
    [PROPERTY_TARGET]: target,
    [PROPERTY_VALUE]: value
  };
}

export function setFilters(target, fundingArea, program, programInstance) {
  return (dispatch) => {
    dispatch(setPropertyValue(SELECTED_FUNDING_AREA, target, fundingArea));
    dispatch(setPropertyValue(SELECTED_PROGRAM, target, program));
    dispatch(setPropertyValue(SELECTED_PROGRAM_INSTANCE, target, programInstance));
  };
}
